module.exports = __webpack_public_path__ + "img/110.the_attitude_of_the_epresentative.ab523f8e.svg";